import { SnakeCaseKeys } from '@/common/types/camel-to-snake-case';

export function camelToSnakeCase(camelCaseString: string): string {
	return camelCaseString.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
}

export function camelToSnakeCaseObject<T>(obj: T): SnakeCaseKeys<T> {
	if (Array.isArray(obj)) {
		return obj.map((item) => camelToSnakeCaseObject(item)) as SnakeCaseKeys<T>;
	}

	if (obj !== null && typeof obj === 'object') {
		return Object.fromEntries(
			Object.entries(obj).map(([key, value]) => [camelToSnakeCase(key), camelToSnakeCaseObject(value)]),
		) as SnakeCaseKeys<T>;
	}

	return obj as SnakeCaseKeys<T>;
}
